/* MENTALLIC™ — Smart Ring product page · v1
   Variant picker (Color × Size) + AJAX add to cart + theme cart drawer + scroll animations.
   Cart drawer render logic mirrors the proven Eye Massager bundle block. */
(function () {
  'use strict';
  if (window._mnrInit) return;
  window._mnrInit = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Ring sizes from the supplier chart: inner diameter (mm); circumference = π·d */
  var SIZES = [ { s: '6', c: 51.8, d: 16.5 }, { s: '7', c: 54.7, d: 17.4 }, { s: '8', c: 57.2, d: 18.2 }, { s: '9', c: 59.7, d: 19.0 }, { s: '10', c: 62.5, d: 19.9 }, { s: '11', c: 65.0, d: 20.7 }, { s: '12', c: 67.5, d: 21.5 }, { s: '13', c: 69.7, d: 22.2 }, { s: '14', c: 72.3, d: 23.0 } ];

  function ringMetal(color) {
    var c = (color || '').toLowerCase();
    if (c.indexOf('gold') > -1) return 'Gold';
    if (c.indexOf('silver') > -1 || c.indexOf('grey') > -1 || c.indexOf('gray') > -1) return 'Silver';
    return 'Black';
  }

  /* delivery window shown once a size is chosen (business days, weekends skipped) */
  function addBusinessDays(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  function showDelivery() {
    var el = document.getElementById('mnrShip'); if (!el || el.dataset.done) return;
    var min = +el.dataset.min || 10, max = +el.dataset.max || 15, now = new Date();
    var f = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    el.innerHTML = '<span>Order today — arrives <b>' + f(addBusinessDays(now, min)) + ' – ' + f(addBusinessDays(now, max)) + '</b> · free tracked shipping</span>';
    el.dataset.done = '1';
  }

  /* honest holiday cutoff: last order day that still arrives (max business days) before the date */
  function showHoliday() {
    var el = document.getElementById('mnrXmas'), ship = document.getElementById('mnrShip');
    if (!el || !ship) return;
    var target = new Date((el.dataset.target || '') + 'T12:00:00'), max = +ship.dataset.max || 15;
    if (isNaN(target)) return;
    var cutoff = new Date(target);
    for (var n = max; n > 0;) { cutoff.setDate(cutoff.getDate() - 1); var w = cutoff.getDay(); if (w !== 0 && w !== 6) n--; }
    var today = new Date(); today.setHours(0, 0, 0, 0);
    if (cutoff < today) return;
    var f = cutoff.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    el.innerHTML = '<span>Order by <b>' + f + '</b> for delivery before ' + (el.dataset.label || 'the holidays') + '</span>';
    el.hidden = false;
  }

  function money(cents) { return '$' + (cents / 100).toFixed(cents % 100 ? 2 : 0); }

  /* ───────── Buy box ───────── */
  function sizeRow(s) { return SIZES.find(function (r) { return r.s === String(s); }); }

  /* small bubble above the tapped size: inner diameter + circumference */
  var tipTimer;
  function showSizeTip(btn, s) {
    var tip = $('#mnrSizeTip'), r = sizeRow(s);
    if (!tip || !r) return;
    var grid = btn && btn.closest('.mnr-sizes');
    if (grid && tip.parentNode !== grid.parentNode) grid.parentNode.insertBefore(tip, grid.nextSibling);
    tip.innerHTML = '<b>US ' + r.s + '</b><span>Inside Ø ' + r.d.toFixed(1) + ' mm</span><span>Around ' + r.c.toFixed(1) + ' mm</span>';
    tip.hidden = false;
    if (btn && grid) {
      var host = grid.parentNode.getBoundingClientRect(), bb = btn.getBoundingClientRect();
      tip.hidden = false;
      var half = tip.offsetWidth / 2, x = bb.left - host.left + bb.width / 2;
      x = Math.max(half, Math.min(host.width - half, x));                 // keep the bubble inside the box
      tip.style.setProperty('--x', x + 'px');
      tip.style.top = (bb.top - host.top - 8) + 'px';
    }
    tip.classList.remove('is-on'); void tip.offsetWidth; tip.classList.add('is-on');
    clearTimeout(tipTimer);
    tipTimer = setTimeout(function () { tip.classList.remove('is-on'); }, 3200);
  }

  /* "Find my size": a sheet over the buy box — no jump down the page and back */
  function initSizeSheet() {
    var sheet = $('#mnrSizeSheet'); if (!sheet || !sheet.showModal) return;
    var input = $('#mnrSheetMm'), out = $('#mnrSheetOut'), use = $('#mnrSheetUse'), chips = $('#mnrSheetChips'), rec = null;
    SIZES.forEach(function (r) {
      var c = document.createElement('span'); c.dataset.s = r.s; c.setAttribute('role', 'button'); c.tabIndex = 0;
      c.innerHTML = '<b>' + r.s + '</b>' + r.c.toFixed(0) + ' mm';
      c.addEventListener('click', function () { input.value = r.c.toFixed(1); input.dispatchEvent(new Event('input')); });
      chips.appendChild(c);
    });
    input.addEventListener('input', function () {
      var v = parseFloat(input.value); rec = null; use.disabled = true;
      $$('span', chips).forEach(function (c) { c.classList.remove('hit'); });
      if (!v) { out.textContent = 'Your size appears here.'; return; }
      if (v < 50) { out.textContent = 'Smaller than our smallest size (US 6, 51.8 mm). Try your index finger.'; return; }
      if (v > 73.5) { out.textContent = 'Larger than our biggest size (US 14, 72.3 mm). Try another finger.'; return; }
      var hit = SIZES.find(function (r) { return r.c >= v - 0.6; }) || SIZES[SIZES.length - 1];
      rec = hit.s; use.disabled = false;
      out.innerHTML = 'Your size: <b>US ' + hit.s + '</b> · inside Ø ' + hit.d.toFixed(1) + ' mm';
      var c = $('span[data-s="' + hit.s + '"]', chips); if (c) c.classList.add('hit');
      use.textContent = 'Use US ' + hit.s;
    });
    $$('[data-size-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); sheet.showModal(); setTimeout(function () { input.focus(); }, 60); });
    });
    $$('[data-size-close]', sheet).forEach(function (b) { b.addEventListener('click', function () { sheet.close(); }); });
    sheet.addEventListener('click', function (e) { if (e.target === sheet) sheet.close(); });
    use.addEventListener('click', function () {
      if (!rec || !window._mnrPickSize) return;
      var b = $('#mnrSizes button[data-value="' + rec + '"]');
      if (b && b.disabled) { out.textContent = 'US ' + rec + ' is sold out in this finish. Try another finish.'; return; }
      sheet.close();
      window._mnrPickSize(rec);
    });
  }

  function initBuy() {
    var dataEl = $('#mnrProduct');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var names = (product.options || []).map(function (o) { return (o.name || o).toString().toLowerCase(); });
    var ci = names.findIndex(function (n) { return /colou?r|finish/.test(n); });
    var si = names.findIndex(function (n) { return /size/.test(n); });

    var state = { color: null, size: null, variant: null, qty: 1, color2: null, size2: '' };
    var packEl = $('#mnrPack'), pct = packEl ? (+packEl.dataset.pct || 0) / 100 : 0;
    var atc = $('#mnrAtc'), hint = $('#mnrSizeHint'), stickyBtn = $('#mnrStickyBtn'), stickyInfo = $('#mnrStickyInfo');
    var label = atc ? atc.dataset.label : 'Add to cart';

    function findVariant(color, size) {
      return product.variants.find(function (v) {
        return (ci < 0 || v.options[ci] === color) && (si < 0 || v.options[si] === size);
      });
    }

    /* per-color stock badge */
    $$('#mnrColors button').forEach(function (b) {
      var ok = product.variants.some(function (v) { return (ci < 0 || v.options[ci] === b.dataset.value) && v.available; });
      var st = $('[data-stock]', b);
      if (st) { st.textContent = ok ? 'In stock' : 'Sold out'; st.classList.toggle('is-out', !ok); }
      b.classList.toggle('is-out', !ok);
    });

    function syncSizes() {
      $$('#mnrSizes button').forEach(function (b) {
        var v = findVariant(state.color, b.dataset.value);
        b.disabled = !v || !v.available;
      });
    }

    function render() {
      state.variant = (si < 0 || state.size) ? findVariant(state.color, state.size) : null;
      var v = state.variant;
      if (!atc) return;
      if (si >= 0 && !state.size) {
        atc.textContent = 'Select your size';
        atc.setAttribute('aria-disabled', 'false');   // actionable: a tap guides to the size picker
        stickyBtn && (stickyBtn.textContent = 'Choose size');
      } else if (!v || !v.available) {
        atc.textContent = 'Sold out';
        atc.setAttribute('aria-disabled', 'true');
      } else if (state.qty === 2 && !state.size2) {
        atc.textContent = 'Pick the second size';
        atc.setAttribute('aria-disabled', 'false');   // actionable: a tap guides to ring 2 sizes
      } else if (state.qty === 2) {
        var v2 = findVariant(state.color2 || state.color, state.size2);
        var both = Math.round((v.price + (v2 ? v2.price : v.price)) * (1 - pct));
        atc.textContent = (v2 && v2.available) ? 'Add both — ' + money(both) : 'Second ring sold out';
        atc.setAttribute('aria-disabled', (v2 && v2.available) ? 'false' : 'true');
        stickyBtn && (stickyBtn.textContent = 'Add both');
      } else {
        atc.textContent = label + ' — ' + money(v.price);
        atc.setAttribute('aria-disabled', 'false');
        stickyBtn && (stickyBtn.textContent = 'Add to cart');
      }
      if (packEl && v) {
        var p1 = $('#mnrPack1'), p2 = $('#mnrPack2');
        if (p1) p1.textContent = money(v.price);
        if (p2) p2.innerHTML = money(Math.round(v.price * 2 * (1 - pct))) + ' <s>' + money(v.price * 2) + '</s>';
      }
      var two = state.qty === 2;
      $$('.mnr-r1').forEach(function (e) { e.hidden = !two; });
      var p1s = $('#mnrPair1'); if (p1s) p1s.textContent = (state.color || '') + ' · ' + (state.size ? 'US ' + state.size : 'pick a size above');
      var p2s = $('#mnrColor2Name'); if (p2s) p2s.textContent = (state.color2 || 'Choose finish') + ' · ' + (state.size2 ? 'US ' + state.size2 : 'pick a size below');
      var p = $('#mnrPrice');
      if (p && v) p.textContent = money(v.price);
      if (stickyInfo) stickyInfo.textContent = [state.color, state.size ? 'Size ' + state.size : null].filter(Boolean).join(' · ') || 'No subscription';
      if (v && window.history && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }

    /* color */
    $$('#mnrColors button').forEach(function (b) {
      b.addEventListener('click', function () {
        $$('#mnrColors button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        state.color = b.dataset.value;
        var n = $('#mnrColorName'); if (n) n.textContent = state.color;
        var det = $('#mnrColorDetail');
        if (det) { det.innerHTML = ''; var bb = document.createElement('b'); bb.textContent = state.color + ' — '; det.appendChild(bb); det.appendChild(document.createTextNode(b.dataset.detail || '')); }
        var m = ringMetal(state.color), body = document.getElementById('mnrRingBody'), rim = document.getElementById('mnrRingRim');
        if (body) body.setAttribute('fill', 'url(#g' + m + 'Band)');
        if (rim) rim.setAttribute('fill', 'url(#g' + m + 'Rim)');
        var lip = document.getElementById('mnrRingLip'); if (lip) lip.setAttribute('fill', 'url(#g' + m + 'Rim)');
        window._mnrMetal = m; document.dispatchEvent(new CustomEvent('mnr:metal', { detail: m }));
        /* jump gallery to this color's photo if the variant has one */
        var withImg = product.variants.find(function (v) { return v.options[ci] === state.color && v.featured_media; });
        var slide = withImg && $('.mnr-gal__slide[data-media-id="' + withImg.featured_media.id + '"]');
        var track = $('#mnrGalTrack');
        if (track) track.scrollTo({ left: slide ? slide.offsetLeft : 0, behavior: 'smooth' });
        syncSizes(); render();
      });
    });

    /* size */
    function pickSize(val) {
      state.size = String(val);
      $$('#mnrSizes button').forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.value === state.size ? 'true' : 'false'); });
      var n = $('#mnrSizeName'); if (n) n.textContent = 'US ' + state.size;
      var sr = sizeRow(state.size);
      if (hint) { hint.classList.remove('err'); hint.innerHTML = sr ? '<b>US ' + sr.s + '</b> fits a finger <b>' + sr.c.toFixed(1) + ' mm</b> around · inside Ø ' + sr.d.toFixed(1) + ' mm. Wrong fit? Free exchange within 30 days.' : 'Free size exchange within 30 days.'; }
      showSizeTip($('#mnrSizes button[data-value="' + state.size + '"]'), state.size);
      var g0 = $('#mnrSizes'); if (g0) g0.classList.remove('need');
      var m0 = $('#mnrAtcMsg'); if (m0) m0.hidden = true;
      showDelivery();
      render();
    }
    window._mnrPickSize = pickSize;
    $$('#mnrSizes button').forEach(function (b) { b.addEventListener('click', function () { if (!b.disabled) pickSize(b.dataset.value); }); });

    /* For two: second ring picker */
    if (packEl) {
      var second = $('#mnrSecond');
      $$('button', packEl).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('button', packEl).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          state.qty = +b.dataset.qty;
          if (second) second.hidden = state.qty !== 2;
          if (state.qty === 2 && !state.color2) { var first = $('#mnrColors2 button[data-value="' + (state.color || '') + '"]') || $('#mnrColors2 button'); first && first.click(); }
          render();
        });
      });
      $$('#mnrColors2 button').forEach(function (b) {
        b.addEventListener('click', function () {
          $$('#mnrColors2 button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          state.color2 = b.dataset.value;
          $$('#mnrSizes2 button').forEach(function (x) { var vv = findVariant(state.color2, x.dataset.value); x.disabled = !vv || !vv.available; });
          if (state.size2) { var cur = $('#mnrSizes2 button[data-value="' + state.size2 + '"]'); if (cur && cur.disabled) state.size2 = ''; }
          render();
        });
      });
      $$('#mnrSizes2 button').forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled) return;
          state.size2 = b.dataset.value;
          $$('#mnrSizes2 button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          var n2 = $('#mnrSize2Name'); if (n2) n2.textContent = 'US ' + state.size2;
          var g2 = $('#mnrSizes2'); if (g2) g2.classList.remove('need');
          showSizeTip(b, state.size2);
          render();
        });
      });
    }

    /* initial state: ?variant= or first available */
    var urlV = new URL(window.location.href).searchParams.get('variant');
    var start = product.variants.find(function (v) { return String(v.id) === urlV; }) ||
                product.variants.find(function (v) { return v.available; }) || product.variants[0];
    state.color = ci >= 0 ? start.options[ci] : null;
    if (urlV && si >= 0) state.size = start.options[si];
    var btn = ci >= 0 && $$('#mnrColors button').find(function (x) { return x.dataset.value === state.color; });
    if (btn) btn.click(); else { syncSizes(); render(); }
    if (state.size) pickSize(state.size);

    function needSize() {
      var g = $('#mnrSizes');
      if (g) {
        g.scrollIntoView({ behavior: 'smooth', block: 'center' });
        g.classList.remove('shake', 'need'); void g.offsetWidth; g.classList.add('shake', 'need');
      }
      if (hint) { hint.classList.add('err'); hint.textContent = 'Pick your size first — or use the size guide below.'; }
      var msg = $('#mnrAtcMsg');
      if (!msg && atc) { msg = document.createElement('p'); msg.id = 'mnrAtcMsg'; msg.className = 'mnr-atc-msg'; msg.setAttribute('role', 'alert'); atc.parentNode.insertBefore(msg, atc); }
      if (msg) { msg.textContent = '↑ Choose your size above to add to cart'; msg.hidden = false; }
    }

    function onAdd() {
      if (si >= 0 && !state.size) return needSize();
      var v = state.variant;
      if (!v || !v.available) return;
      var items = [{ id: v.id, quantity: 1 }];
      if (state.qty === 2) {
        if (!state.size2) {
          var g2 = $('#mnrSizes2');
          if (g2) { g2.scrollIntoView({ behavior: 'smooth', block: 'center' }); g2.classList.remove('shake', 'need'); void g2.offsetWidth; g2.classList.add('shake', 'need'); }
          return;
        }
        var v2 = findVariant(state.color2 || state.color, state.size2);
        if (!v2 || !v2.available) return;
        items = v2.id === v.id ? [{ id: v.id, quantity: 2 }] : [{ id: v.id, quantity: 1 }, { id: v2.id, quantity: 1 }];
      }
      atc.classList.add('is-loading');
      cartAdd(items)
        .then(function (res) { renderDrawer(res.sections); triggerOpen(); })
        .catch(function (e) { if (hint) { hint.classList.add('err'); hint.textContent = e.message || 'Could not add to cart. Please try again.'; } })
        .then(function () { atc.classList.remove('is-loading'); });
    }
    atc && atc.addEventListener('click', onAdd);
    stickyBtn && stickyBtn.addEventListener('click', onAdd);
  }

  /* ───────── Cart (same approach as Eye Massager bundle block) ───────── */
  function detectCartSectionId() {
    if (document.getElementById('shopify-section-cart-drawer')) return 'cart-drawer';
    if (document.getElementById('shopify-section-cart-notification')) return 'cart-notification';
    var el = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var node = el && el.parentNode;
    while (node && node.tagName !== 'BODY') {
      if (node.id && node.id.indexOf('shopify-section-') === 0) return node.id.slice(16);
      node = node.parentNode;
    }
    return 'cart-drawer';
  }
  var CART_SID = detectCartSectionId();

  function cartAdd(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: [CART_SID, 'cart-icon-bubble'].join(','), sections_url: window.location.pathname })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'HTTP ' + r.status); });
      return r.json();
    });
  }

  function renderDrawer(sections) {
    if (!sections) return;
    var iconEl = document.getElementById('cart-icon-bubble');
    if (iconEl && sections['cart-icon-bubble']) {
      var tmp = document.createElement('div');
      tmp.innerHTML = sections['cart-icon-bubble'];
      var fresh = tmp.querySelector('#cart-icon-bubble');
      iconEl.innerHTML = fresh ? fresh.innerHTML : sections['cart-icon-bubble'];
    }
    var sectionEl = document.getElementById('shopify-section-' + CART_SID);
    if (sectionEl && sections[CART_SID]) sectionEl.innerHTML = sections[CART_SID];
  }

  function triggerOpen() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    var btn = document.querySelector('[aria-controls="CartDrawer"], cart-drawer-opener button, #cart-icon-bubble');
    if (btn) btn.click(); else window.location.href = '/cart';
  }

  /* ───────── Gallery ───────── */
  function initGallery() {
    var track = $('#mnrGalTrack'), dots = $('#mnrGalDots');
    if (!track || !dots) return;
    var n = track.children.length;
    if (n <= 1) { dots.style.display = 'none'; return; }
    for (var i = 0; i < n; i++) (function (i) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Slide ' + (i + 1));
      b.onclick = function () { track.scrollTo({ left: track.children[i].offsetLeft, behavior: 'smooth' }); };
      dots.appendChild(b);
    })(i);
    function setDot() {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('on', i === j); });
    }
    track.addEventListener('scroll', function () { requestAnimationFrame(setDot); }, { passive: true });
    setDot();
  }

  /* ───────── Size guide ───────── */
  function initSizing() {
    var tbl = $('#mnrSizeTable'), input = $('#mnrMm'), out = $('#mnrCalcOut'), use = $('#mnrUseSize');
    if (!tbl || !input) return;
    SIZES.forEach(function (r) {
      var tr = document.createElement('tr'); tr.dataset.s = r.s;
      tr.innerHTML = '<td>' + r.s + '</td><td>' + r.c.toFixed(1) + ' mm</td><td>' + r.d.toFixed(1) + ' mm</td>';
      tbl.appendChild(tr);
    });
    var rec = null;
    input.addEventListener('input', function () {
      var v = parseFloat(input.value);
      $$('tr', tbl).forEach(function (t) { t.classList.remove('hit'); });
      use.style.display = 'none'; rec = null; use.textContent = 'Use this size'; use.classList.remove('is-done');
      if (!v) { out.textContent = 'Enter your measurement to see your size.'; return; }
      if (v < 50) { out.textContent = 'Under 50 mm is smaller than our smallest size (US 6, 51.8 mm). Try measuring your index finger.'; return; }
      if (v > 73.5) { out.textContent = 'Over 73.5 mm is larger than our biggest size (US 14, 72.3 mm). Try a different finger.'; return; }
      var hit = SIZES.find(function (r) { return r.c >= v - 0.6; }) || SIZES[SIZES.length - 1];
      rec = hit.s;
      out.innerHTML = 'Your size <b>US ' + hit.s + '</b>';
      var row = $('tr[data-s="' + hit.s + '"]', tbl); if (row) row.classList.add('hit');
      use.style.display = 'flex';
    });
    use.addEventListener('click', function () {
      if (!rec || !window._mnrPickSize) return;
      var b = $('#mnrSizes button[data-value="' + rec + '"]');
      if (b && b.disabled) { out.textContent = 'US ' + rec + ' is sold out in this finish. Try another finish.'; return; }
      window._mnrPickSize(rec);
      // stay here: confirm in place; the sticky bar below is ready to add to cart
      use.textContent = '✓ US ' + rec + ' selected';
      use.classList.add('is-done');
      out.innerHTML = 'Your size <b>US ' + rec + '</b> is selected — tap <b>Add to cart</b> below.';
    });
  }

  /* ───────── Animations ───────── */
  function initAnim() {
    var st = $('#mnrStages');
    if (st && !st.children.length) {
      [[3,'#3a3a3a'],[2,'#e6e6e1'],[4,'#8a8a8a'],[1,'#3a3a3a'],[3,'#e6e6e1'],[5,'#8a8a8a'],[1,'#c9a46a'],[3,'#8a8a8a'],[2,'#e6e6e1'],[4,'#8a8a8a'],[1,'#c9a46a'],[3,'#8a8a8a']]
        .forEach(function (p, i) { var e = document.createElement('i'); e.style.flex = p[0]; e.style.background = p[1]; e.style.transitionDelay = (i * 60) + 'ms'; st.appendChild(e); });
    }
    if (!('IntersectionObserver' in window)) { $$('.mnr .rv').forEach(function (el) { el.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var t = e.target; t.classList.add('in'); io.unobserve(t);
        if (t.id === 'mnrPhone') {
          var arc = $('#mnrArc'), num = $('#mnrNum'), target = +(num && num.dataset.score || 82);
          if (arc) arc.style.strokeDashoffset = 502 * (1 - target / 100);
          if (st) st.classList.add('in');
          var t0 = performance.now();
          (function f(now) { var p = Math.min((now - t0) / 1800, 1); if (num) num.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(f); })(t0);
        }
      });
    }, { threshold: 0.2 });
    $$('.mnr .rv').forEach(function (el) { io.observe(el); });

    var bars = $('#mnrBars');
    if (bars) {
      var bio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          $$('.mnr-bar__fill', bars).forEach(function (f, i) { f.style.animationDelay = (i * 250) + 'ms'; });
          bars.classList.add('play');
          bio.disconnect();
        });
      }, { threshold: 0.15 });
      bars.classList.add('pre'); bio.observe(bars);
      setTimeout(function () { bars.classList.add('play'); }, 6000);   // failsafe: never leave the chart empty
    }

    var sticky = $('#mnrSticky'), atc = $('#mnrAtc'), fin = $('#mnrFinal');
    if (sticky && atc) {
      var pastBuy = false, atFinal = false;
      var upd = function () { sticky.classList.toggle('show', pastBuy && !atFinal); };
      new IntersectionObserver(function (es) { var e = es[0]; pastBuy = !e.isIntersecting && e.boundingClientRect.top < 0; upd(); }).observe(atc);
      if (fin) new IntersectionObserver(function (es) { atFinal = es[0].isIntersecting; upd(); }).observe(fin);
    }
  }


  /* ───────── 24 hours scroll story ───────── */
  function initDay() {
    var sec = document.getElementById('mnrDay');
    if (!sec) return;
    var n = 4, cur = -1;
    var bgs = $$('.mnr-day__bg', sec), scenes = $$('.mnr-day__scene', sec), cards = $$('.mnr-day__card', sec), rail = $$('.mnr-day__rail li[data-i]', sec);
    function countUp(el) {
      var to = +el.dataset.count, from = +(el.dataset.from || 0), t0 = performance.now(), D = 1400;
      (function f(now) { var p = Math.min((now - t0) / D, 1), e = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(from + (to - from) * e); if (p < 1) requestAnimationFrame(f); })(t0);
    }
    function activate(i) {
      if (i === cur) return; cur = i;
      [bgs, scenes, cards, rail].forEach(function (list) { list.forEach(function (el) { el.classList.toggle('is-on', +el.dataset.i === i); }); });
      var card = cards[i];
      if (!card) return;
      var arc = $('.mnr-day__arc', card); if (arc) { arc.style.strokeDashoffset = 314; requestAnimationFrame(function () { arc.style.strokeDashoffset = 314 * (1 - 0.84); }); }
      var num = $('[data-count]', card); if (num) countUp(num);
    }
    function onScroll() {
      var r = sec.getBoundingClientRect(), total = sec.offsetHeight - window.innerHeight;
      var p = Math.min(Math.max(-r.top / Math.max(total, 1), 0), 0.9999);
      activate(Math.floor(p * n));
    }
    window.addEventListener('scroll', function () { requestAnimationFrame(onScroll); }, { passive: true });
    onScroll();
  }


  /* ───────── Sleep playground (illustrative model) ───────── */
  function initLab() {
    var bed = $('#mnrLabBed'), wake = $('#mnrLabWake');
    if (!bed || !wake) return;
    var arc = $('#mnrLabArc'), scoreEl = $('#mnrLabScore'), word = $('#mnrLabWord'), tip = $('#mnrLabTip'), total = $('#mnrLabTotal');
    var bars = $$('#mnrLabBars > div'), shown = 0;
    var flags = { coffee: $('#mnrLabCoffee'), screen: $('#mnrLabScreen'), late: $('#mnrLabLate'), wine: $('#mnrLabWine') };
    function clock(h) { h = ((h % 24) + 24) % 24; var hh = Math.floor(h), mm = Math.round((h - hh) * 60); if (mm === 60) { hh++; mm = 0; } var ap = hh >= 12 && hh < 24 ? 'PM' : 'AM'; var h12 = hh % 12 || 12; return h12 + ':' + (mm < 10 ? '0' : '') + mm + ' ' + ap; }
    function hm(h) { var m = Math.round(h * 60); return Math.floor(m / 60) + 'h ' + (m % 60 < 10 ? '0' : '') + (m % 60) + 'm'; }
    function animateTo(target) {
      var from = shown, t0 = performance.now();
      (function f(now) { var p = Math.min((now - t0) / 600, 1), v = Math.round(from + (target - from) * (1 - Math.pow(1 - p, 3))); scoreEl.textContent = v; if (p < 1) requestAnimationFrame(f); else shown = target; })(t0);
      arc.style.strokeDashoffset = 490 * (1 - target / 100);
    }
    function update() {
      var b = +bed.value, w = +wake.value + 24, inBed = w - b;
      $('#mnrLabBedOut').textContent = clock(b); $('#mnrLabWakeOut').textContent = clock(w);
      var lat = 0.25 + (flags.coffee.checked ? 0.35 : 0) + (flags.screen.checked ? 0.25 : 0) + (flags.late.checked ? 0.15 : 0);
      var awake = 0.35 + (flags.coffee.checked ? 0.3 : 0) + (flags.wine.checked ? 0.35 : 0) + (flags.late.checked ? 0.1 : 0);
      var asleep = Math.max(inBed - lat - awake, 2);
      var deepPct = 0.2 - (flags.coffee.checked ? 0.05 : 0) - (flags.wine.checked ? 0.03 : 0) - (flags.late.checked ? 0.02 : 0);
      var remPct = 0.22 - (flags.wine.checked ? 0.07 : 0) - (flags.screen.checked ? 0.02 : 0) - (asleep < 6.5 ? 0.04 : 0);
      var deep = asleep * deepPct, rem = asleep * remPct, light = asleep - deep - rem;
      var durScore = Math.max(0, Math.min(1, (asleep - 4.5) / 3.3));
      var score = Math.round(38 + durScore * 48 + (deepPct - 0.13) * 90 + (remPct - 0.13) * 60 - awake * 6 - (b > 24.5 ? 4 : 0));
      score = Math.max(28, Math.min(96, score));
      animateTo(score);
      word.textContent = score >= 85 ? 'Excellent' : score >= 75 ? 'Good night' : score >= 60 ? 'Fair' : 'Rough night';
      total.textContent = hm(asleep);
      [[deep, deep / asleep * 2.2], [light + rem, (light + rem) / asleep * 0.9], [lat, lat / 1.2], [awake, awake / 1.2]].forEach(function (x, i) {
        var row = bars[i]; if (!row) return;
        $('em', row).style.width = Math.min(100, Math.round(x[1] * 100)) + '%';
        $('b', row).textContent = hm(x[0]);
      });
      var tips = [];
      if (asleep < 7) tips.push('Going to bed 30 minutes earlier would add more deep sleep than any other change here.');
      if (flags.coffee.checked) tips.push('Late caffeine usually shows up as a longer time to fall asleep.');
      if (flags.wine.checked) tips.push('Alcohol tends to make the second half of the night more restless.');
      if (flags.screen.checked) tips.push('Screens in bed push sleep later — try leaving the phone across the room.');
      if (flags.late.checked) tips.push('A late workout raises resting heart rate into the night.');
      tip.textContent = tips[0] || 'Nice. A steady bedtime keeps this score up night after night.';
    }
    [bed, wake].concat(Object.keys(flags).map(function (k) { return flags[k]; })).forEach(function (el) { el.addEventListener('input', update); el.addEventListener('change', update); });
    var started = false;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { if (es[0].isIntersecting && !started) { started = true; update(); } }, { threshold: 0.3 }).observe($('#mnrLab'));
    } else update();
  }


  /* ───────── Inside the app tour ───────── */
  function initApp() {
    var sec = document.getElementById('mnrApp');
    if (!sec) return;
    var items = $$('#mnrAppList li', sec), screens = $$('.mnr-app__screen', sec), tabs = $$('.mnr-app__tabbar button', sec);
    var cur = -1, timer = null, visible = false, DUR = 5200;
    sec.style.setProperty('--dur', DUR + 'ms');
    function fmt(n) { return n >= 1000 ? n.toLocaleString('en-US') : String(n); }
    function count(el) { var to = +el.dataset.count, t0 = performance.now(); (function f(now) { var p = Math.min((now - t0) / 1200, 1); el.textContent = fmt(Math.round(to * (1 - Math.pow(1 - p, 3)))); if (p < 1) requestAnimationFrame(f); })(t0); }
    function show(i) {
      cur = i;
      items.forEach(function (li, k) { li.classList.remove('is-on'); void li.offsetWidth; if (k === i) li.classList.add('is-on'); });
      screens.forEach(function (sc, k) { sc.classList.toggle('is-on', k === i); });
      tabs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      var sc = screens[i];
      $$('.mnr-app__arc', sc).forEach(function (a) { a.style.strokeDashoffset = 314; requestAnimationFrame(function () { a.style.strokeDashoffset = 314 * (1 - (+a.dataset.v || 0)); }); });
      $$('[data-count]', sc).forEach(count);
      clearTimeout(timer);
      if (visible) timer = setTimeout(function () { show((cur + 1) % screens.length); }, DUR);
    }
    items.forEach(function (li, k) { $('button', li).addEventListener('click', function () { show(k); }); });
    /* tap the phone's own tab bar */
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    /* swipe left/right on the phone screen */
    var phone = $('.mnr-app__phone', sec), sx = null, sy = null;
    if (phone) {
      phone.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      phone.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show((cur + (dx < 0 ? 1 : screens.length - 1)) % screens.length);
      }, { passive: true });
    }
    new IntersectionObserver(function (es) {
      visible = es[0].isIntersecting;
      if (visible) show(cur < 0 ? 0 : cur); else clearTimeout(timer);
    }, { threshold: 0.35 }).observe(sec);
  }

  function initTouch() {
    var t = document.getElementById('mnrTouch'); if (!t) return;
    if (!('IntersectionObserver' in window)) { t.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { t.classList.add('is-in'); io.disconnect(); } }, { threshold: 0.3 });
    io.observe(t);
  }

  function initMoments() {
    var sec = document.getElementById('mnrMoments'); if (!sec) return;
    var words = sec.querySelectorAll('.mnr-moments__row span'); if (!words.length) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    sec.classList.add('is-focus');
    var on = false, raf = 0;
    function tick() {
      var r = sec.getBoundingClientRect(), cx = r.left + r.width / 2, half = Math.max(r.width * 0.32, 160);
      for (var i = 0; i < words.length; i++) {
        var b = words[i].getBoundingClientRect();
        if (b.right < r.left - 40 || b.left > r.right + 40) continue;
        var d = Math.min(Math.abs(b.left + b.width / 2 - cx) / half, 1);
        var k = 1 - d * d * (3 - 2 * d);
        words[i].style.opacity = (0.16 + 0.84 * k).toFixed(3);
      }
      if (on) raf = requestAnimationFrame(tick);
    }
    if (!('IntersectionObserver' in window)) { on = true; tick(); return; }
    new IntersectionObserver(function (es) {
      on = es[0].isIntersecting; cancelAnimationFrame(raf); if (on) tick();
    }).observe(sec);
  }

  function init() { initGallery(); initBuy(); initSizing(); initAnim(); initDay(); showHoliday(); initLab(); initApp(); initTouch(); initMoments(); initSizeSheet(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
